module.exports = __webpack_public_path__ + "img/option_one.b5bd201c.png";